
import React, { useState, useEffect, useRef } from "react";

const Failure_Cards_List = ({ month, year, rcId, responseCode }) => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchOnce = useRef(false);

    useEffect(() => {
        if (!month || !year || !rcId || !responseCode || fetchOnce.current) return;

        fetchOnce.current = true;
        setLoading(true);
        setError("");
        setList([]);

        const fetchData = async () => {
            try {
                const params = new URLSearchParams({ month, year, rcId, responseCode });
                const res = await fetch(
                    `${process.env.REACT_APP_URL_HEADER}/api/failure_cards_list?${params}`,
                    { credentials: "include" }
                );

                if (!res.ok) throw new Error("Failed to fetch data");

                const data = await res.json();
                setList(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [month, year, rcId, responseCode]);

    if (loading) return <div align="center">Loading details...</div>;
    if (error) return <div style={{ color: "red" }}>{error}</div>;
    if (!list.length) return <div align="center">Details Not Found</div>;

    return (
        <table align="center" width="70%" border="1" style={{ marginTop: "20px" }}>
            <thead>
                <tr className="tableheader">
                    <th colSpan="4">
                        Details for RC {rcId} with Error Code {responseCode}
                    </th>
                </tr>
                <tr className="tableheader">
                    <th>Sl No</th>
                    <th>FPS id</th>
                    <th>Member Name</th>
                    <th>Authentication Time</th>
                </tr>
            </thead>
            <tbody>
                {list.map((item, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.fps_id}</td>
                        <td>{item.member_name_en}</td>
                        <td>{item.auth_time}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default Failure_Cards_List;